import React from "react";
import { truncate } from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";

function CombineLedger(props) {
  const { gridVal } = props;

  const showCombineData = (data) => {
    return (
      data &&
      data.map((item, index) => {
        const date = item.date || "-";
        const voucherType = item.voucherType || "-";
        const exchange = item.exchange || "-";
        const narration = item.narration || "-";
        const debit = item.debit || "-";
        const credit = item.credit || "-";
        const runningBalance=item?.runningBalance

        return (
          <tr key={index}>
            <td>{date}</td>
            <td>{voucherType}</td>
            <td>{exchange}</td>
            <td className="tooltip123">
              {truncate(narration)}
              <span className="tooltiptext">{narration}</span>
            </td>
            <td>{debit}</td>
            <td>{credit}</td>
            <td>{runningBalance}</td>
          </tr>
        );
      })
    );
  };

  return (
    <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table combine-ledger">
        <thead>
          <tr>
            <th scope="col">{Constants.Date}</th>
            <th scope="col" className="text-center">
              {Constants.Voucher_Type}
            </th>
            <th scope="col" className="text-center">
              {Constants.Exchange}
            </th>
            <th scope="col" className="text-center">
              {Constants.Narration}
            </th>
            <th scope="col" className="text-center">
              {Constants.Debit}
            </th>
            <th scope="col" className="text-center">
              {Constants.Credit}
            </th>
            <th scope="col" className="text-center">
              {Constants.Running_Balance}
            </th>
          </tr>
        </thead>
        <tbody>{showCombineData(gridVal)}</tbody>
      </table>
    </div>
  );
}

export default CombineLedger;
